
    import { defineComponent, type PropType, toRef } from 'vue'

    import { useColumnLayout } from '@/app/composables/column-layout'
    import PostPreview from '@/app/components/common/posts/PostPreview.vue'

    import type { Post } from '@/common/models/data/dashboard/posts/post'

    export default defineComponent({
        components: {
            PostPreview
        },
        props: {
            entries: {
                type: Array as PropType<Array<Post>>,
                required: true
            }
        },
        setup (props) {
            return {
                ...useColumnLayout(2, toRef(props, 'entries'))
            }
        }
    })
